import React from 'react'
import { apiFetch } from '../fetchApi';

export const updateLanguage = ({ BeURL, topInput, showAlert, setLanguage, editingCardId, handleTopClear, candidateId }) => {
    apiFetch(`${BeURL}/language/${editingCardId}`, {
        method: "PUT",
       
        body: JSON.stringify({ topInput, candidateId }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setLanguage(data.languages)
                handleTopClear()
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in update language", err);
        });
}
